module.exports = __webpack_public_path__ + "static/media/left-detail-turnout.deb5e6d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/left-detail-turnout.jpg
// module id = 700
// module chunks = 0